module.exports = {"410526100":"道口镇","410526101":"城关镇","410526102":"白道口镇","410526103":"留固镇","410526104":"上官镇","410526105":"牛屯镇","410526106":"万古镇","410526107":"高平镇","410526108":"王庄镇","410526109":"老店镇","410526110":"慈周寨镇","410526111":"焦虎镇","410526200":"枣村乡","410526201":"四间房乡","410526202":"八里营乡","410526203":"赵营乡","410526204":"大寨乡","410526205":"桑村乡","410526206":"老爷庙乡","410526209":"瓦岗寨乡","410526211":"半坡店乡","410526212":"小铺乡","410526400":"新区管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410526.json
// module id = 1442
// module chunks = 0